import cn from 'classnames';

import DesktopSlider from 'components/common/DesktopSlider';

import css from 'styles/components/productdetail/sizeGroupsSlider.scss';

const getCardWidth = mobile => (mobile ? 230 : 300);
const getSlideWidth = mobile => getCardWidth(mobile) + 10;
const getNumCardsToShow = mobile => (mobile ? 1.1 : 2.44);

const makeSliderCallbacks = ({ length: numGroups }, leftOrRight) => {
  if (leftOrRight === 'Left') {
    return {
      disabledFn: ({ currentSlide }) => currentSlide === 0,
      getClickFn: ({ previousSlide }) => previousSlide
    };
  } else {
    const disabledFn = ({ currentSlide, slideCount }) => currentSlide === slideCount || currentSlide >= numGroups - 2;
    const getClickFn = ({ nextSlide }) => nextSlide;
    return { disabledFn, getClickFn };
  }
};

const makeSliderDecoratorComponent = (groups, leftOrRight) => {
  const { disabledFn, getClickFn } = makeSliderCallbacks(groups, leftOrRight);
  const styleClass = leftOrRight === 'Left' ? css.carouselLeft : css.carouselRight;
  const chevron = <div className={css.sliderChevron} />;
  return props => {
    const otherProps = {
      className: cn(styleClass, { [css.disabled]: disabledFn(props) }),
      onClick: getClickFn(props)
    };
    return <button type="button" {...otherProps}>{chevron}</button>;
  };
};

const makeSliderDecorator = (groups, leftOrRight) => {
  const component = makeSliderDecoratorComponent(groups, leftOrRight);
  const position = `Center${leftOrRight}`;
  return { component, position };
};

const makeSliderDecorators = groups => [
  makeSliderDecorator(groups, 'Left'),
  makeSliderDecorator(groups, 'Right')
];

const makeDesktopSlider = ({ cards, groups, mobile }) => {
  const sliderProps = {
    decorators: makeSliderDecorators(groups),
    framePadding: '0',
    slidesToShow: getNumCardsToShow(mobile),
    slidesToScroll: 1,
    slideWidth: `${getSlideWidth(mobile)}px`
  };
  return <DesktopSlider {...sliderProps}>{cards}</DesktopSlider>;
};

const SizeGroupsSlider = props => {
  const className = props.mobile ? css.mobileSlider : css.desktopSlider;
  return <div className={className}>{makeDesktopSlider(props)}</div>;
};

export default SizeGroupsSlider;
